'use client';

import { Divider } from '@stone-payments/jade';
import { RecurrencePlanSummary } from '../../app/components/recurrence/recurrencePlanSummary';
import { usePageDataAdapter } from '../../hooks/usePageDataAdapter';
import { DetailCheckout } from '../detailCheckout';
import { SummaryDetail } from './sumaryDetail';
import { SummaryDynamicView } from './summaryDynamicView';

type SummaryProps = {
  compactLayout?: boolean;
  screen: string;
  detailTitle?: string;
  totalLabel?: string;
};

export function Summary({ compactLayout = false, screen, detailTitle, totalLabel }: SummaryProps) {
  const { detailItems, isRecurrence, items, total } =
    usePageDataAdapter();

  return (
    <div className='flex flex-col gap-jade-300'>
      {isRecurrence ? (
        <SummaryDynamicView
          content={
            <RecurrencePlanSummary />
          }
          formattedAmount={total.formattedAmount}
          suppressOnMobile={!compactLayout}
          screen={screen}
        />
      ) : (
        <SummaryDynamicView
          content={
            compactLayout ? (
              <div className='flex flex-col'>
                <DetailCheckout items={detailItems} title={detailTitle} removeBorderRadiusBottom />
                <Divider />
                <SummaryDetail items={items} total={total} totalLabel={totalLabel} removeBorderRadiusTop />
              </div>
            ) : (
              <>
                <DetailCheckout items={detailItems} title={detailTitle} />
                <SummaryDetail items={items} total={total} totalLabel={totalLabel} />
              </>
            )
          }
          formattedAmount={total.formattedAmount}
          suppressOnMobile={!compactLayout}
          screen={screen}
        />
      )}
    </div>
  );
}
